<template>
  <div class="threshold-alert-status">
    <div class="threshold-alert-status__field threshold-alert-status__field--until-alert" v-if="event.latest">
      <div class="mr-3">
        {{ $t('untilAlert', { value: insectsUntilAlert }) }}
      </div>
      <div class="threshold-alert-status__progress">
        <div class="flex">
          <v-progress-linear
            class="mb-1"
            :color="insectsUntilAlert > 0 ? 'primary' : 'warning'"
            :value="event.count * 100 / event.sensor_threshold"
            height="15"
          />
          <v-btn
            depressed
            rounded
            small
            color="white"
            @click.stop="openDialog"
            v-if="editable"
          >
            {{ $t('button.update_threshold') }}
          </v-btn>
        </div>
        <div
          class="threshold-alert-status__led"
          :class="{
            'threshold-alert-status__led--red': insectsUntilAlert <= 0,
            'threshold-alert-status__led--green': insectsUntilAlert > 0,
          }"
        />
      </div>
    </div>
    <div class="threshold-alert-status__field">
      {{ `${$t('sensor_threshold')} : ${event.sensor_threshold}` }}
    </div>
    <v-dialog v-model="dialog" max-width="300" content-class="threshold-alert-status__dialog">
      <v-form v-model="valid">
        <v-text-field
          v-model="model"
          type="number"
          autofocus
          :label="$t('threshold')"
          :rules="validationRules.threshold"
          v-if="dialog"
        />
        <v-text-field
          v-model="increaseModel"
          type="number"
          :label="$t('increase_threshold')"
          :rules="validationRules.increaseThreshold"
          v-if="dialog"
        />
      </v-form>
      <div class="d-flex justify-end">
        <v-btn
          color="primary"
          class="ma-0 "
          @click="submit"
          :disabled="isSubmitDisabled"
        >
          {{ $t('button.update') }}
        </v-btn>
      </div>
    </v-dialog>
  </div>
</template>

<i18n lang="yaml">
ja:
  untilAlert: "アラートが出るまでの頭数: {value}"
  threshold: "累積アラート用しきい値"
  increase_threshold: "差分アラート用しきい値"
  sensor_threshold: アップロード時のしきい値
  button:
    update_threshold: しきい値再設定
    update: 更新

en:
  untilAlert: "{value} more insects until alert."
  threshold: "Cumulative Alert Threshold"
  increase_threshold: "Differential Alert Threshold"
  sensor_threshold: Threshold when photo was uploaded
  button:
    update_threshold: Update threshold
    update: Update
</i18n>

<script>
import Notifications from '@/mixins/notifications';
import Validations from '@/components/Form/mixins/form-validations';

export default {
  name: 'threshold-alert-status',
  props: {
    event: {
      type: Object,
      default() {
        return {};
      },
    },
    editable: Boolean,
  },
  mixins: [Validations, Notifications],
  computed: {
    insectsUntilAlert() {
      const { count, sensor_threshold: threshold } = this.event;
      if (count > threshold) {
        return 0;
      }
      return threshold - count;
    },
    isSubmitDisabled() {
      return !this.valid || (
        this.model === this.event.sensor_threshold &&
        this.increaseModel === this.event.sensor_increase_threshold
      );
    },
    validationRules() {
      return {
        threshold: [
          this.required(this.$t('threshold')),
          this.positive(this.$t('threshold')),
        ],
        increaseThreshold: [
          this.required(this.$t('increase_threshold')),
          this.positive(this.$t('increase_threshold')),
        ],
      };
    },
  },
  data() {
    return {
      dialog: false,
      model: 0,
      increaseModel: 0,
      valid: false,
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
      this.model = this.event.sensor_threshold;
      this.increaseModel = this.event.sensor_increase_threshold;
    },
    submit: async function () {
      this.$emit('updateThreshold', {
        threshold: Number(this.model),
        increase_threshold: Number(this.increaseModel),
      });
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="sass">
@import 'vuetify/src/styles/styles.sass'

.threshold-alert-status
  &__field--until-alert
    display: flex
    flex-wrap: wrap
    align-items: flex-start !important

  &__progress
    min-width: 200px
    max-width: 300px
    display: flex
    flex-wrap: nowrap
    flex-grow: 1
    margin-top: 0.25rem
    margin-bottom: 0.5rem

    .v-btn
      margin-bottom: 0
      width: 100%

  &__led
    height: 50px
    width: 50px
    background-image: url(../../../assets/logo-no.png)
    background-size: cover
    background-repeat: no-repeat
    background-position: center
    margin-left: 0.5rem

    &--green
      background-image: url(../../../assets/logo-green.png)

    &--red
      background-image: url(../../../assets/logo-red.png)
</style>

<style lang="sass">
.threshold-alert-status
  &__dialog
    background-color: #fff
    padding: 1rem
    width: 300px
</style>
